import { render, staticRenderFns } from "./share-email.vue?vue&type=template&id=76f47407&"
import script from "./share-email.js?vue&type=script&lang=js&"
export * from "./share-email.js?vue&type=script&lang=js&"
import style0 from "./share-email.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports